<template>
  <div class="robotItem">
    <div class="up">
      <div class="logo">
        <img :src="item.companyLogo1" />
        <el-tag size="small"> {{ item.version }} {{this.$t('robotItem.ver')}} </el-tag>
      </div>
      <div class="name">
        <el-badge v-if="item.status===1" :value="this.$t('robotItem.online')" type="warning">{{ item.name }}</el-badge>
        <el-badge v-else :value="this.$t('robotItem.offline')" type="info">{{ item.name }}</el-badge>
      </div>
      <div class="date">
        <div>
          <font-awesome-icon :icon="['far', 'calendar-alt']" />&ensp;{{
            item.avialableDate
          }}
        </div>
        <div v-show="crontableDescription !== ''">
          <font-awesome-icon :icon="['far', 'clock']" />&ensp;{{
            crontableDescription
          }}
        </div>
      </div>
    </div>
    <div class="down">
      <div class="comment">{{ item.comment }}</div>
      <div class="btns">
        <el-button
          size="small"
          icon="el-icon-video-play"
          @click="handleClickRun(item.id, item.name)"
          :disabled="item.status === 1 || crontableDescription === ''"
          round
          >{{this.$t('robotItem.online')}}</el-button
        >
        <el-button
          size="small"
          icon="el-icon-video-pause"
          @click="handleClickStop(item.id, item.name)"
          :disabled="item.status === 0"
          round
          >{{this.$t('robotItem.offline')}}</el-button
        >
        <!--el-button
          size="small"
          @click="handleClickUpgrade(item.id, item.name, item.version)"
          :disabled="item.status === 1 || crontableDescription === ''"
          >{{this.$t('robotItem.update')}}</el-button
        -->
        <el-button size="small" @click="handleClickConfig(item.id,item.name, item.crontable) "
          round
        >{{this.$t('robotItem.config')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDescriptionByCrontable } from "@/utils/robot/robot.js";
export default {
  name: "RobotItem",
  props: {
    item: Object,
    handleClickRun: Function,
    handleClickStop: Function,
    handleClickUpgrade: Function,
    handleClickConfig: Function
  },
  computed: {
    crontableDescription() {
      return getDescriptionByCrontable(this.item.crontable);
    }
  }
};
</script>
<style>
.robotItem {
  display: flex;
  flex-direction: column;
  height: 320px;
  width: 320px;
  margin: 0px 35px 35px 0px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
}
.robotItem .up {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  flex: 1;
  border-bottom: 1px solid #e5e5e5;
  background-color: #0B7CC4;
}
.robotItem .up div {
  flex: 1;
}
.robotItem .up .logo {
  display: flex;
  justify-content: space-between;
}
.robotItem .up .logo img {
  max-height: 50px;
}
.robotItem .up .name {
  color: #eee;
  font-size: 16px;
  font-weight: 600;
}

.robotItem .up .date {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ccc;
}
.robotItem .down {
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  flex: 1;
}
.robotItem .down .comment {
  font-size: 14px;
  color: #999;
}
.robotItem .down .btns {
  display: flex;
  align-items: center;
}
.robotItem .down div {
  flex: 1;
}
</style>
